<template>
  <div>
    <v-navbar
      v-if="quiz.customer"
      class="navbar-question navbar--feedback"
      :logo="quiz.customer.logo"
      :darkMode="quiz.dark_mode > 0"
    />
    <div class="feedback">
      <v-lottie
        :options="successOptions"
        height="300px"
        width="300px"
        ref="refSuccess"
      />
      <p class="feedback__title">Enviado com sucesso!</p>
      <p class="feedback__description">
        {{ customer.company_name }} agradece sua colaboração!!!
      </p>
    </div>
  </div>
</template>

<script>
import * as success from "@/assets/animations/success-animation.json";
import VLottie from "@/components/VLottie.vue";
import VNavbar from "./components/VNavbar.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "FeedbackExterno",
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  components: {
    VLottie,
    VNavbar
  },
  data: () => ({
    successOptions: {
      animationData: success,
      autoplay: true,
      loop: false
    }
  }),
  mounted() {
    if (!this.currentQuestion.uuid) {
      this.$router.push({
        name: "response-externo",
        params: { id: this.id }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearStore();
    if (to.name === "response-externo") next();
    else
      next({
        name: "response-externo",
        params: { id: this.id }
      });
  },
  computed: {
    ...mapState("Quiz", {
      quiz: state => state.quiz,
      currentQuestion: state => state.currentQuestion,
      customer(state) {
        return this.quiz.customer;
      }
    })
  },
  methods: {
    ...mapActions("Quiz", ["clearStore"])
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.navbar--feedback {
  margin: 0;
}

.feedback {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media #{$small-and-down} {
    justify-content: center;
  }

  &__title {
    font-size: 48px;
    font-weight: bold;
    margin: 0 0 24px 0;

    @media #{$small-and-down} {
      font-size: 32px;
    }
  }

  &__description {
    font-size: 24px;
    margin: 0;

    @media #{$small-and-down} {
      font-size: 16px;
    }
  }
}
</style>
